import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sortByOrder } from "../helpers";
import api from "../providers/api";

const initialState = { strategies: [], isLoading: true };

export const getPillars = createAsyncThunk("get-pillars", async () => {
  const response = await api.strategy.getAllWithPillars();

  response.Data.map((item) => {
    return { ...item, Pillars: sortByOrder(item.Pillars) };
  });

  return response?.Data;
});

const pillarSlice = createSlice({
  name: "pillar",
  initialState,
  reducers: {
    updatePillar: (state, action) => {
      if (state.strategies?.length === 0) return;
      const strategyIndex = state.strategies.findIndex(
        (pillar) => pillar.ID === action.payload?.Strategy?.ID
      );

      const itemIndex = state.strategies?.[strategyIndex].Pillars.findIndex(
        (pillar) => pillar.ID === action.payload?.ID
      );

      if (itemIndex !== -1) {
        state.strategies[strategyIndex].Pillars[itemIndex] = action.payload;
      } else {
        state.strategies[strategyIndex].Pillars.push(action.payload);
      }

      state.strategies.map((item) => {
        return {
          ...item,
          Pillars: sortByOrder(item.Pillars),
        };
      });
    },
    deletePillar: (state, { payload: { strategyIndex, id } }) => {
      const itemIndex = state.strategies[strategyIndex].Pillars.findIndex(
        (pillar) => pillar.ID === id
      );

      if (itemIndex !== -1) {
        state.strategies[strategyIndex].Pillars.splice(itemIndex, 1);
      }
    },
  },
  extraReducers: {
    [getPillars.fulfilled]: (state, action) => {
      state.strategies = action.payload;
      state.isLoading = false;
    },
    [getPillars.pending]: (state) => {
      state.isLoading = true;
    },
    [getPillars.rejected]: (state) => {
      state.isLoading = false;
      // addToast.error("error", {
      //   toastId: "error",
      // });
    },
  },
});

export const { updatePillar, deletePillar } = pillarSlice.actions;

export default pillarSlice.reducer;
